import dsBridge from 'dsbridge'
import router from '@/router'
import { Locale } from 'vant'
// @ts-ignore
import enUS from 'vant/es/locale/lang/en-US.mjs'
// @ts-ignore
import zhCN from 'vant/es/locale/lang/zh-CN.mjs'
import { useUserStore } from '@/stores/user'

export const getAppRequestHeader = () => {
  const str: any = dsBridge.hasNativeMethod('getAppRequestHeader')
    ? dsBridge.call('getAppRequestHeader')
    : '{}'
  const data = JSON.parse(str)
  const { setRequestHeader } = useUserStore()
  setRequestHeader(data)
  console.log('getAppRequestHeader', data)
  return data
}

export const getUserInfo = async () => {
  const { setUserInfo, userInfo } = useUserStore()
  const str = dsBridge.call('getUserInfo', 'getUserInfo')
  console.log('getUserInfo', str)
  if (str) {
    const data = JSON.parse(str)
    if (!data?.safeArea) {
      data.safeArea = {}
      data.safeArea.top = 0
      data.safeArea.bottom = 0
    }
    setUserInfo(data || { safeArea: { top: 0, bottom: 0 } })
  }
  // 更新语言
  const langType: any = userInfo.langType || 'zh' // zh en
  if (langType === 'zh') {
    Locale.use('zh-CN', zhCN)
  }
  if (langType === 'en') {
    Locale.use('en-US', enUS)
  }
  localStorage.setItem('langType', langType)
}

export const registerPreviousH5 = () => {
  // 定义返回方法供android调用（虚拟按键及滑动手势返回）
  dsBridge.register('previous', function () {
    console.log('previous')
    const isApp = router.currentRoute.value.meta?.isApp
    // const match = window.location.href.match(/#\/([^?]+)/)
    // const path: any = match ? match[1] : null
    // if (pathHomes.includes(path)) {
    //   nativeBack()
    // } else {
    //   router.go(-1)
    // }
    if (isApp) {
      nativeBack()
    } else {
      router.go(-1)
    }
  })
}

export const onNativeShare = (desc: string) => {
  dsBridge.hasNativeMethod('onNativeShare')
    ? dsBridge.call('onNativeShare', desc)
    : '{}'
}

export const nativeBack = () => {
  localStorage.removeItem('my_costomer_user')
  localStorage.removeItem('my_costomer_vip_base')
  dsBridge.call('finish', 'finish')
  console.log('原生返回')
}

export const trackClick = (data: any) => {
  const desc = JSON.stringify(data)
  dsBridge.hasNativeMethod('trackClick')
    ? dsBridge.call('trackClick', desc)
    : '{}'
}
